<template>
  <EasyDataTable
    v-bind="$attrs"
    :headers="headers"
    :items="items"
    :sort-by="sortBy"
    :sort-type="sortType"
    :rows-per-page="rowsPerPage"
    :hide-rows-per-page="hideRowsPerPage"
    :table-class="tableClass"
    :header-class="headerClass"
    :body-row-class="bodyRowClass"
    :buttons-pagination="false"
    :hide-footer="true"
  >
    <template v-for="header in headers" :key="header.value" #[`item-${header.value}`]="row">
      <slot :name="`item-${header.value}`" v-bind="row">
        {{ row[header.value] }}
      </slot>
    </template>
  </EasyDataTable>
</template>

<script setup lang="ts">
import EasyDataTable, { type Header, type SortType, type BodyRowClassFunction } from "vue3-easy-data-table";

const props = defineProps<{
  headers: Header[];
  items: any[];
  sortBy?: string;
  sortType?: SortType;
  rowsPerPage?: number;
  hideRowsPerPage?: boolean;
  tableClass?: string;
  headerClass?: string;
  bodyRowClass?: BodyRowClassFunction | string;
}>();

const sortBy = props.sortBy ?? "";
const sortType = props.sortType ?? "asc";
const rowsPerPage = props.rowsPerPage ?? 10;
const hideRowsPerPage = props.hideRowsPerPage ?? false;
const tableClass = props.tableClass ?? "";
const headerClass = props.headerClass ?? "";
const bodyRowClass = props.bodyRowClass ?? "";
</script>
